export const permissionType = {
    1: 'permanent',
    2: 'temporary',
};
